import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getCheckpoints, getEventConfigCheckpoints } from "../../../api";

const useCheckpoints = ({
	search = "",
	hiddenCheckpoints = [],
	queryParams = {},
	select = v => v,
	eventId = null,
	enabled = true
} = {}) => {
	const organization = useSelector(
		({ organization }) => organization.organization
	);

	const finalQueryParams = {
		archived: false,
		search,
		...(eventId ? {} : { with_event_config_checklists: false }),
		...queryParams
	};

	return useQuery(
		["checkpoints", organization.id(), eventId, search, finalQueryParams],
		() =>
			eventId === null
				? getCheckpoints(organization.id(), finalQueryParams).then(
						resp => ({
							data: resp.data,
							totalCount: resp.headers?.get("total-count")
						})
				  )
				: getEventConfigCheckpoints(
						organization.id(),
						eventId,
						finalQueryParams
				  ).then(({ response, headers }) => ({
						data: response,
						totalCount: headers?.get("total-count")
				  })),
		{
			enabled,
			select: result => {
				const filteredData = result.data.filter(
					({ id, cashless_zone_id }) =>
						!hiddenCheckpoints.includes(id) &&
						(eventId || !cashless_zone_id)
				);
				return {
					data: select(filteredData),
					totalCount: result.totalCount
				};
			}
		}
	);
};

export default useCheckpoints;
